module.exports = __webpack_public_path__ + "static/media/team_work_cn02.39005c40.png";